export const REALTOR_FORM_LINK_TO_CATALOG = 'realtor_form_link_to_catalog';
export const PHONE_STEP_POSITION = 'realtor_form_phone_step_position';
export const DEAL_PERIOD_EXPERIMENT = 'realtor_form_deal_period_experiment';

export const EXPERIMENTS = [REALTOR_FORM_LINK_TO_CATALOG, PHONE_STEP_POSITION, DEAL_PERIOD_EXPERIMENT];
